import React, { ReactElement, FunctionComponent } from "react";
import { ResponsiveBar } from "@nivo/bar";
import { GraphProps } from "../../../wrappers/LoadingGraph";

const AdsOver90DaysGraph: FunctionComponent<GraphProps> = ({
  records,
}: GraphProps): ReactElement => (
  <ResponsiveBar
    data={records}
    keys={["ads"]}
    indexBy="yearweek"
    animate={true}
    axisTop={null}
    axisRight={null}
    enableGridY={false}
    enableGridX={false}
    margin={{ top: 50, right: 20, bottom: 50, left: 60 }}
    axisBottom={{
      tickSize: 5,
      tickPadding: 5,
      tickRotation: 0,
      legend: "YearWeek",
      legendPosition: "middle",
      legendOffset: 40,
    }}
    axisLeft={{
      tickSize: 5,
      tickPadding: 5,
      tickRotation: 0,
      legend: "# Of Ads",
      legendPosition: "middle",
      legendOffset: -40,
    }}
  />
);

export default AdsOver90DaysGraph;
